var render = function render(_c,_vm){return _c('div',{staticClass:"loader",style:({ width: _vm.width, height: _vm.height })},[_c('Spinner',{attrs:{"color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }